import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Chip } from "@material-ui/core";
import { ThreeDots } from "react-loader-spinner";

export default function SectionVariants({
  isLoading,
  variants,
  selectedVariant,
  onSelect,
  color,
  getTableDescription,
  classes,
}) {
  const model01Description = getTableDescription("model01");

  return (
    <Box className={classes.headerVariantsContainer}>
      <Typography className={classes.sectionTitle}>
        1. Variants to be configured | {model01Description}
      </Typography>

      {isLoading && (
        <ThreeDots color={color} ariaLabel="loading" height={20} width={40} />
      )}

      {!isLoading && variants.length === 0 && (
        <Typography className={classes.noVariantsMessage}>
          No variants available for this model
        </Typography>
      )}

      {!isLoading &&
        variants.length > 0 &&
        variants.map((variant) => (
          <Chip
            key={variant.variant_id}
            label={variant.variant_name}
            onClick={() => onSelect(variant.variant_id)}
            className={
              selectedVariant === variant.variant_id
                ? `${classes.variantChip} selected`
                : classes.variantChip
            }
          />
        ))}
    </Box>
  );
}

SectionVariants.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      variant_id: PropTypes.number.isRequired,
      variant_name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedVariant: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  getTableDescription: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};
